// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"31f15b8d","81":"926aa476","134":"ec42829a","269":"c50b5dfc","351":"457ca348","715":"03422a2f","787":"bb67526b","972":"ad1153e2"}[chunkId] + ".chunk.js";
};